import { render, staticRenderFns } from "./ServiceSpend.vue?vue&type=template&id=480f7bd0&scoped=true&"
import script from "./ServiceSpend.vue?vue&type=script&lang=js&"
export * from "./ServiceSpend.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSpend.vue?vue&type=style&index=0&id=480f7bd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f7bd0",
  null
  
)

export default component.exports